import { createSelector } from 'reselect';

// Config
import { getIsApplicationSelector, getAppOrderCompleteSelector } from '@redux/reducers/app/appSelector';
import { getConfirmationOrderSelector } from '@redux/reducers/confirmation/orderConfirmationSelector';
import {
  getDeliveriesSelector,
} from '@redux/reducers/delivery/deliverySelector';
import { getPersonalisedItems } from '@utils/personalisation/personalisationHelp';

const getItems = createSelector(
  [getDeliveriesSelector],
  (deliveries = []) => getPersonalisedItems({ deliveries }),
);

export const shouldShowOrderPersonalisation = createSelector(
  [getItems, getAppOrderCompleteSelector],
  (items, orderComplete) => items && items.length > 0 && orderComplete,
);

const orderPersonalisationState = createSelector(
  [getIsApplicationSelector, getItems, shouldShowOrderPersonalisation, getConfirmationOrderSelector],
  (isApplication, items, shouldShow, order) => ({
    isApplication,
    items,
    shouldShow,
    order,
  }),
);

export default orderPersonalisationState;
